import { Voucher } from '../../../pages/reporting/vouchers/types'

const voucherEndpoints = {
  list: () => `/reporting/vouchers` as const,
  types: () => `/reporting/vouchers/types` as const,
  xlsx: () => `/reporting/vouchers/xlsx` as const,
  accounting: () => `/accounting/vouchers` as const,
  accountingDetail: (voucherId: Voucher['id']) => `/accounting/vouchers/${voucherId}` as const,
  deleteAttachment: (voucherId: string, attachmentId: string) =>
    `/accounting/vouchers/${voucherId}/attachments/${attachmentId}` as const,
  getAttachment: (voucherId: string, attachmentId: string) =>
    `/accounting/vouchers/${voucherId}/attachments/${attachmentId}` as const
}

export default voucherEndpoints
